// extracted by mini-css-extract-plugin
export default {"title":"GroupUserCard-module__title--ZG+0+","name":"GroupUserCard-module__name--dxgHt","animatedBackground":"GroupUserCard-module__animatedBackground--JC9gG"};